import { useContext } from 'react';
import { MessageContext } from './context';
import type { MessageApi } from './types';

export const useMessage = (): MessageApi => {
    const api = useContext(MessageContext);
    if (!api) {
        throw new Error('useMessage must be used inside <MessagesProvider>.');
    }
    return api;
};
